import React from "react"
import ErrorPage from "@src/components/ui/ErrorPage"

const Page401: React.FC = () => {
  return (
    <ErrorPage
      code={401}
      title="Unauthorized"
      description="You do not have permission to access this resource. Please log in with an account that has the necessary permissions."
      primary={{ label: "Go to login", to: "/login" }}
      secondary={{ label: "Go to home", to: "/" }}
    />
  )
}

export default Page401
